import { NgModule } from '@angular/core';
import { HelpycurrencyPathPipe } from './helpycurrency.pipe';
@NgModule({
    imports: [],
    declarations: [
        HelpycurrencyPathPipe,
    ],
    exports: [
        HelpycurrencyPathPipe,
    ]
})

export class HelpycurrencyModule{}
